const MainBannerImage = ({className, image}: {className: string, image: string}) => {
    return (
        <>
            <img className={className} src={image} alt="Banner image"/>
        </>
    )
}

export default MainBannerImage;
